import cn from "classnames";
import React from "react";

import { makeBEM } from "utils";

import "./index.scss";

export interface CardProps extends React.HTMLProps<HTMLDivElement> {
  type?: "primary" | "secondary";
}

const bem = makeBEM("card");

export const Card = React.forwardRef<HTMLDivElement, CardProps>(({ className, type = "primary", ...props }, ref) => {
  return <div ref={ref} className={cn(bem(null, [type]), className)} {...props} />;
});
